import { UNIQUE_SCREEN_CODE, SCREEN_ID_ENUM, UNIQUE_SCREEN_IDENTIFIER } from '@/constants';
import { ScreenEvent } from '@/types/api/login';
import http from '@/utils/http';
import config from '@/config';
import { AxiosResponse } from 'axios';

export async function getScreenEvents(): Promise<ScreenEvent> {
  const screenCode = localStorage.getItem(UNIQUE_SCREEN_CODE);
  const response = await http.get<ScreenEvent>(
    `${config.apiUrl}userapi/screen-event?uniqueScreenCode=${screenCode}&_=${Date.now()}`,
    {
      'axios-retry': {
        retries: 0,
      },
    },
  );
  return response.data;
}

export async function saveScreenEvents(
  patchRequest: Record<string, string | boolean>,
): Promise<AxiosResponse> {
  const screenCode = localStorage.getItem(UNIQUE_SCREEN_CODE);
  const response = await http.patch<AxiosResponse>(`${config.apiUrl}userapi/screen-event`, {
    ...patchRequest,
    uniqueScreenCode: screenCode,
  });
  return response.data;
}

export async function saveDeviceInfo(deviceInfo: Record<string, any>) {
  const screenCode = localStorage.getItem(UNIQUE_SCREEN_CODE);
  if (deviceInfo && deviceInfo.platformInfo && deviceInfo.platformInfo.serialNumber) {
    localStorage.setItem(UNIQUE_SCREEN_IDENTIFIER, deviceInfo.platformInfo.serialNumber);
  }
  if (window.isAndroid) {
    const originalFirmwareVersion = deviceInfo['platformInfo']['firmwareVersion'];
    const appInfo = deviceInfo['appInfo'];
    if (appInfo && appInfo.appVersion) {
      deviceInfo['platformInfo']['firmwareVersion'] = `${
        originalFirmwareVersion ? originalFirmwareVersion + ' ' : ''
      }${appInfo.appVersion} v${appInfo.appVersionCode || ''}`;
    }
  }
  await http.post<AxiosResponse>(
    `${config.apiUrl}userapi/screen-info`,
    Object.assign({}, deviceInfo, {
      uniqueScreenCode: screenCode,
      playerVersion: config.version,
    }),
  );
}

export async function uploadScreenshot(screenshotBase64: string) {
  const response = await http.post<AxiosResponse>(`${config.apiUrl}userapi/screenshot`, {
    screenshot: screenshotBase64,
    timestamp: new Date().toISOString(),
  });
  return response.data;
}

export async function sendLogoutNotification(message: string, serialNumber: string) {
  const response = await http.post<AxiosResponse>(
    `${config.apiUrl}userapi/screen-offline-notification/${serialNumber}`,
    {
      message,
    },
  );
  return response.data;
}

export async function sendScreenRefreshEvent() {
  await http.post<AxiosResponse>(`${config.apiUrl}userapi/screen-refresh-event`, {});
}
